export default __webpack_public_path__ + "static/media/2_4_1920xSlider4.9b6679de.png";